<template>
  <div class="d-flex flex-column w-100 h-100 justify-content-center align-items-center">
    <div class="mw-100 p-5">
      <img class="w-100" v-if="status === 'activityBefore' || status === 'activityAfter'" src="@/assets/images/illustration/undraw_blank_page.svg" alt="">
      <img class="w-100" v-else src="@/assets/images/illustration/undraw_oops.svg" alt="">
    </div>
    <div class="font-size-md text-center">
      <div v-if="status === '' || status === 'activityNotExist' || status === 'activityBefore' || status === 'activityAfter' || status === 'activitySendExceed'" v-html="getWording()" />
      <i18n :path="getWording()" tag="div" v-if="status !== 'activityNotExist' && status === 'activityBefore' && status === 'activityAfter' && status !== ''">
        <template v-slot:click v-if="status">
          <a href="javascript:void(0)" @click="goLogin">{{ $t('global.click-here') }}</a>
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commonTool from '../utils/commonTool';

export default {
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['beforeWording',
      'afterWording']),
  },
  methods: {
    getWording() {
      switch (this.status) {
        // 登入失敗
        case 'login':
          return 'error.login-fail';
        // 無效 access token
        case 'accessTokenInvalid':
          return 'error.access-token-invalid';
        // 活動不存在
        case 'activityNotExist':
          return this.$t('error.activity-does-not-exist');
        // 活動未開始
        case 'activityBefore':
          return this.beforeWording;
          // 活動已結束
        case 'activityAfter':
          return this.afterWording;
        // 授權
        case 'authorization':
          return 'error.please-allow-authorization';
        // 網路不穩
        case 'unstableNetwork':
          return 'error.unstable-network';
        // 發送數量達上限
        case 'activitySendExceed':
          return this.$t('error.activity-send-exceed');
        default:
          return this.$t('error.page-not-found');
      }
    },
    goLogin() {
      commonTool.login(this.$route.query.path);
    },
  },
};
</script>
